<rid-mechanic-background />

<rid-mechanic-wrapper>
  <rid-top-bar [progress]="index()" [steps]="exercises().length" class="block w-full" name="Sommen" />

  <rid-mechanic-content>
    <div class="flex items-center justify-center">
      @for (exercise of [exercise()]; track exercise) {
        <p
          animate.enter="wait-300 anim-pop-in"
          animate.leave="anim-fade-out"
          class="font-family-din absolute text-8xl font-black text-white drop-shadow-2xl transition-colors"
        >
          {{ exercise[1] }} {{ operator() }} {{ exercise[2] }} =

          @for (state of [state()]; track state) {
            @if (state === 'VISIBLE') {
              <span animate.enter="wait-300 anim-pop-in" animate.leave="anim-fade-out" class="absolute pl-[0.5ch]">?</span>
            } @else if (state === 'ANSWER') {
              <span animate.enter="wait-300 anim-pop-in" animate.leave="anim-fade-out" class="absolute pl-[0.5ch] text-emerald-500">{{
                answer()
              }}</span>
            }
          }
        </p>
      }
    </div>

    @if (state() === 'ANSWER') {
      <rid-assessment-toast (assessed)="$event === 'CORRECT' ? markCorrect() : markIncorrect()" />
    }
  </rid-mechanic-content>
</rid-mechanic-wrapper>
